import { useState, useEffect } from 'react';
import LoginPage from './LoginPage';
import Home from './Home';
import Callback from './Callback';

function App() {
  const [currentPage, setCurrentPage] = useState('login');
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    // Check if we're in a callback URL
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');

    if (status === 'failure' || status === 'success') {
      setCurrentPage('callback');
      return;
    }

    // Strict protection: Check if user is authorized
    const isLoggedIn = sessionStorage.getItem('isLoggedIn');
    const userEmail = sessionStorage.getItem('userEmail');
    const userName = sessionStorage.getItem('userName');
    const loginTimestamp = sessionStorage.getItem('loginTimestamp');

    if (isLoggedIn === 'true' && userEmail && userName && loginTimestamp) {
      setIsAuthorized(true);
      setCurrentPage('home');
    } else {
      // Clear all auth data if incomplete
      sessionStorage.removeItem('isLoggedIn');
      sessionStorage.removeItem('userEmail');
      sessionStorage.removeItem('userName');
      sessionStorage.removeItem('loginTimestamp');
      setIsAuthorized(false);
      setCurrentPage('login');
    }
  }, []);

  // Watch for page changes and validate authorization
  useEffect(() => {
    if (currentPage === 'home') {
      const isLoggedIn = sessionStorage.getItem('isLoggedIn');
      const userEmail = sessionStorage.getItem('userEmail');
      const userName = sessionStorage.getItem('userName');
      const loginTimestamp = sessionStorage.getItem('loginTimestamp');

      if (isLoggedIn === 'true' && userEmail && userName && loginTimestamp) {
        setIsAuthorized(true);
      } else {
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('userEmail');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('loginTimestamp');
        setIsAuthorized(false);
        setCurrentPage('login');
      }
    }
  }, [currentPage]);

  const handleLogout = () => {
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('loginTimestamp');
    setIsAuthorized(false);
    setCurrentPage('login');
  };

  return (
    <>
      {currentPage === 'login' && (
        <LoginPage setCurrentPage={setCurrentPage} />
      )}
      {currentPage === 'home' && isAuthorized && (
        <Home onLogout={handleLogout} />
      )}
      {currentPage === 'home' && !isAuthorized && (
        <LoginPage setCurrentPage={setCurrentPage} />
      )}
      {currentPage === 'callback' && (
        <Callback setCurrentPage={setCurrentPage} />
      )}
    </>
  );
}

export default App;
